// Libs / Helpers
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { isUserAuthenticatedSelector } from '../../selectors';
import * as authActions from '../../actions/authActions';
import * as types from '../../actions/actionTypes';
import { logoutFromCache } from '../../api/authApi';
import { unlockCase } from 'Apis/caseDataAPI.js';
import { bindActionCreators } from 'redux';
import {
  clearLockedCaseArray,
  clearTabNumber,
  removeRecentCasesCount,
  clearLockedImageArray,
} from 'Utils/localStorageUtils.js'

import useSession from 'Components/session/session';
import {
  unLockGetNextCases,
  unlockImage } from 'Apis/queueManagerApi.js';
import { loadActiveCases } from '../../store/browserStorage';
import { unlockAllCases } from 'Apis/caseDataAPI.js';

export const Logout = ({ logoutUser }) => {
  const session = useSession();

  useEffect(() => {
    const performLogout = async () => {
      try {
        const state = JSON.parse(sessionStorage.getItem('state'));
        
        // Unlock cases and images before logout
        if (state?.auth?.user?.userId) {
          console.log('[Logout] Unlocking user cases...');
          await unLockGetNextCases(state.auth.user.userId);
        }

        const tokenExpiry = state?.auth?.tokenExpiry;
        const isTokenValid = tokenExpiry && (tokenExpiry - Date.now() > 0);

        if (isTokenValid) {
          console.log('[Logout] Unlocking cases and images...');
          await Promise.all([
            unlockCase(),
            unlockImage()
          ]);
        }

        // Backend logout call
        console.log('[Logout] Calling backend logout...');
        await logoutFromCache();

        console.log('[Logout] Pre-logout cleanup completed successfully');
      } catch (error) {
        console.error('[Logout] Pre-logout cleanup error:', error);
        // Continue with logout even if cleanup fails
      } finally {
        // Clear local data regardless of API call success
        clearLockedCaseArray();
        clearTabNumber();
        removeRecentCasesCount();
        clearLockedImageArray();
        
        // Clear Redux state before logout
        logoutUser();
        
        // Trigger session logout which includes pendo.clearSession() and GP Auth logout
        console.log('[Logout] Triggering session logout...');
        await session.logout();
      }
    };

    performLogout();
  }, [session, logoutUser]);

  return (
    <section className="container">
      <BVLoader20 />
    </section>
  );
};

Logout.propTypes = {
  logoutUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isUserAuthenticated: isUserAuthenticatedSelector(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch),
    logoutUser: () => dispatch({ type: types.LOGOUT_USER }),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Logout));
